import { FC } from 'react'

import { Faq } from 'api'
import { cn } from 'utils'
import { FaqLink } from 'components/faqs'

import classes from './faq-search.module.css'

interface ResultProps {
  typing: boolean
  searching: boolean
  isDirty: boolean
  data?: Faq[]
}

export const Result: FC<ResultProps> = ({ typing, searching, data, isDirty }) => {
  if (!isDirty) {
    return <span className={cn(classes.statusInfo)}>Please type your question</span>
  }

  if (typing) {
    return <span className={cn(classes.statusInfo, classes.inProcess)}>Typing...</span>
  }

  if (searching) {
    return <span className={cn(classes.statusInfo, classes.inProcess)}>Searching...</span>
  }

  if (!data?.length) {
    return <span className={classes.statusInfo}>No Result</span>
  }

  return (
    <div className={classes.listContainer}>
      <ul className={classes.list}>
        {data.map(({ id, slug, title }) => (
          <li key={id} className={classes.item}>
            <FaqLink title={title} slug={slug} className={classes.link} />
          </li>
        ))}
      </ul>
    </div>
  )
}
